<template>
	<ClientOnly>
		<div
			v-if="ad"
			ref="adRoot"
			class="related-post ad-butler-related-post aizen-related-post-ad"
		>
			<div
				v-if="imageUrl"
				class="related-post-image"
				style="max-width: 140px"
			>
			<a
				:href="trackingLink"
				target="_blank"
				rel="noopener noreferrer"
				@click.passive="onAdClick"
			>
				<img
						height="640"
						width="640"
						:src="imageUrl"
						alt="Ad buttler Image for recomended post"
						loading="lazy"
					/>
				</a>
			</div>

			<div class="related-post-info">
				<div class="flex">
					<a
						:href="trackingLink"
						target="_blank"
						rel="noopener noreferrer"
					>
						<h6 style="text-align: left !important">{{ headline }}</h6>
					</a>
				</div>

				<p v-if="body">{{ body }}</p>

				<a
					:href="trackingLink"
					target="_blank"
					rel="noopener noreferrer"
					class="read-more-link"
				>
					{{ cta }}
				</a>
			</div>
		</div>
	</ClientOnly>
</template>

<script setup>
const props = defineProps({
	slotId: {
		type: String,
		default: "b1dff869-fe38-4ae5-b936-960cc33da5a0"
	}
});

const AIZEN_BASE_URL = "https://aizen-ad-manager.up.railway.app";

const ad = useState(`aizen-ad-${props.slotId}`, () => null);
const adLoading = useState(`aizen-ad-loading-${props.slotId}`, () => false);
const impressionTracked = useState(
	`aizen-ad-impression-${props.slotId}`,
	() => false
);

const adRoot = ref(null);

const normalizeAizenUrl = (url) => {
	if (!url) {
		return null;
	}
	if (url.startsWith("http://") || url.startsWith("https://")) {
		return url;
	}
	return `${AIZEN_BASE_URL}${url}`;
};

const { pageKey } = usePageKey()
const adCtx = computed(() => ({ pageKey: pageKey.value, surface: "related" }))
const trackingLink = computed(() =>
	buildAdClickUrl(
		normalizeAizenUrl(ad.value?.clickUrl) || ad.value?.destinationUrl || "#",
		adCtx.value
	)
);
const onAdClick = () => fireAdClickEvent(adCtx.value)

const imageUrl = computed(() => ad.value?.imageUrl || "");

const headline = computed(() => {
	const properties = ad.value?.properties || {};
	return properties.title || ad.value?.name || "";
});

const body = computed(() => {
	const properties = ad.value?.properties || {};
	return (
		properties.body ||
		properties.Body ||
		properties.description ||
		properties.Description ||
		""
	);
});

const cta = computed(() => {
	const properties = ad.value?.properties || {};
	return properties.cta_label || properties.cta || properties.CTA || "Read more";
});

useAizenImpression(
	adRoot,
	() => normalizeAizenUrl(ad.value?.impressionUrl),
	{ firedRef: impressionTracked }
);

const fetchAd = async () => {
	if (ad.value || adLoading.value) {
		return;
	}

	adLoading.value = true;
	try {
		const response = await $fetch(
			`${AIZEN_BASE_URL}/api/slots/${props.slotId}/serve`
		);

		if (response?.clickUrl || response?.destinationUrl) {
			ad.value = response;
		}
	} catch {
	} finally {
		adLoading.value = false;
	}
};

const scheduleFetch = () => {
	const load = () => {
		fetchAd();
	};

	if (typeof window.requestIdleCallback === "function") {
		window.requestIdleCallback(load, { timeout: 2000 });
		return;
	}

	window.setTimeout(load, 0);
};

onMounted(() => {
	if (process.client) {
		scheduleFetch();
	}
});
</script>
